<div class="body-main" *ngIf="emailsettingsNumber==0">
    <div class="body-main-top">
  
      <section class="container-fluid mt-2 mt-md-3 mb-4">
        <div class="row">
          <div class="box col-12">
            <div class="box-header">
              <div class="box-title">
                <div class="row align-items-center">
                  <div class="col">
                    <h3>Email Settings</h3>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                
  
                <form  [formGroup]="myEmailForm" (ngSubmit)="saveEmailSettings(myEmailForm.value)" novalidate>
                    <div class="form-group row">
                        <label for="inputPassword3" class="col-sm-2 col-form-label">Content type</label>
                        <div class="col-sm-10"> 
                            <select class="form-control" formControlName="contentType" (change)="checkoptions()" id="exampleFormControlSelect2">
                                <option value="0">Select type</option>
                                <option value="email">Email</option>
                                <option value="sms">SMS</option> 
                              </select>  
                              <div class="alert alert-danger" *ngIf="contentTypeStatus">
                                  Please select content type.
                              </div>   
                        </div>
                      </div>
                      <div class="form-group row">
                          <label for="inputPassword3" class="col-sm-2 col-form-label">Content option type</label>
                          <div class="col-sm-10">
                              <select class="form-control" formControlName="contentOptionType" (change)="checkoptions()" id="exampleFormControlSelect2">
                                  <option value="0">Select type</option>
                                  <option value="initial">INITIAL</option>
                                  <option value="paid">PAID</option> 
                                  <option value="nofee"> NOFEE </option>
                                  <option value="forgot_password"> FORGOT PASSWORD </option>
                                </select> 
                                <div class="alert alert-danger" *ngIf="contentOptionTypestatus">
                                    Please select content type.
                                </div>    
                            <!-- <input type="password" class="form-control" id="inputPassword3" placeholder="Password"> -->
                          </div>
                        </div>    
                        <ng-template [ngIf]="mobilesms" [ngIfElse]="onlysms">
                        <div class="form-group row">
                            <label for="inputPassword3" class="col-sm-2 col-form-label">Email Subject</label>
                            <div class="col-sm-10"> 
                              <input type="text" formControlName="subject" class="form-control" id="inputPassword3" placeholder="Email Subject">
                              <div class="alert alert-danger" *ngIf="isSubject && isSubmitted">
                                  please add email subject 
                                </div>
                            </div>
                          </div>       
                  <div class="form-group row">
                    <label for="EmailContent" class="col-sm-2 col-form-label">Content</label>
                    <div class="col-sm-10"> 
                        <p-editor formControlName="description" [style]="{'height':'320px'}"></p-editor>
                        <div class="alert alert-danger" *ngIf="isSubmitted && (myEmailForm.controls['description'].hasError('required') || myEmailForm.controls['description'].hasError('dirty') || myEmailForm.controls['description'].hasError('touched'))">
                            please add email content 
                          </div>
                    </div>
                  </div> 
                </ng-template>
                <ng-template #onlysms>
                  <div class="form-group row">
                    <label for="EmailContent" class="col-sm-2 col-form-label">Content</label>
                    <div class="col-sm-10"> 
                        <textarea formControlName="description" rows="6" style="width:100%"></textarea> 
                        <div class="alert alert-danger" *ngIf="isSubmitted && (myEmailForm.controls['description'].hasError('required') || myEmailForm.controls['description'].hasError('dirty') || myEmailForm.controls['description'].hasError('touched'))">
                          please add sms content 
                        </div>
                        <!-- <p-dropdown [options]="cities" formControlName='selectedCity' [(ngModel)]="selectedCity" [filter]="true"></p-dropdown> -->
                      <!-- <input type="email" class="form-control" id="inputEmail3" placeholder="Email"> -->
                    </div>
                  </div> 
                </ng-template>  
                <div class="form-group row">
                  <div class="col-sm-2 col-form-label"></div>
                  <div class="col-sm-10">Note: Use API name inside <span>{{</span> <span>}}</span> for Dynamic content Replacement.<br/>For Ex. <span>{{</span>registration_no<span>}}</span> <span>{{</span>password<span>}}</span> <br/>API Name can be found at particular Field which is created in FormBuilder Admin Panel.</div>
                </div>
                <!--<div class="form-group row">
                    <div class="col-sm-2 col-form-label"></div>
                    <div class="col-sm-10"> 
                  <button type="button" id="cb" class="btn btn-light" (click)="toltipfun('Hello Clipboard!')" data-toggle="tooltip" data-placement="top" title="click to copy">
                    Tooltip on top
                  </button> 
                  </div>
                </div>-->
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <ng-template [ngIf]="editButton" [ngIfElse]="addbuton">
                          <button type="submit" class="btn btn-primary"> Update </button>
                      </ng-template>
                      <ng-template #addbuton>
                          <button type="submit" class="btn btn-primary"> Add </button>
                      </ng-template>
                    </div>
                  </div>
                </form>  
              </div>
            </div>
          </div>
        </div>
      </section>